"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.printSyntax = void 0;
function printPath(items) {
    return items.reduce((acc, item) => {
        if (item.type === "identifier" || item.type === "property") {
            return acc + item.text;
        }
        if (item.type === "predicate") {
            return `${acc}[${printSyntax(item.expression)}]`;
        }
        return acc;
    }, "");
}
function printFunctionCall(path, args) {
    const pathString = printPath(path.items);
    const parameters = args.map(printSyntax).join(", ");
    return `${pathString}(${parameters})`;
}
function printMap(items) {
    if (items.length === 0) {
        return "[:]";
    }
    const mapEntries = items
        .map((item) => {
        const key = printSyntax(item.key);
        const value = printSyntax(item.value);
        return `${key}: ${value}`;
    })
        .join(", ");
    return `[${mapEntries}]`;
}
function printArray(items) {
    return `[${items.map((item) => printSyntax(item)).join(", ")}]`;
}
function printUnary(exp, parentPrecedence) {
    const precedence = getPrecedence(exp);
    const needsParentheses = precedence > parentPrecedence;
    const output = `${exp.token.text}${printSyntax(exp.operand, precedence)}`;
    return needsParentheses ? `(${output})` : output;
}
function printOperator(exp, parentPrecedence) {
    const precedence = getPrecedence(exp);
    const needsParentheses = precedence > parentPrecedence;
    const output = `${printSyntax(exp.left, precedence)} ${exp.token.text} ${printSyntax(exp.right, precedence)}`;
    return needsParentheses ? `(${output})` : output;
}
function printTernary(exp, parentPrecedence) {
    const precedence = getPrecedence(exp);
    const needsParentheses = precedence > parentPrecedence;
    const output = `${printSyntax(exp.conditional, precedence)} ? ${printSyntax(exp.truthy, precedence)} : ${printSyntax(exp.falsy, precedence)}`;
    return needsParentheses ? `(${output})` : output;
}
function printSyntax(exp, parentPrecedence = Infinity) {
    switch (exp.type) {
        case "string":
            return exp.text;
        case "number":
            return exp.text;
        case "boolean":
            return exp.token.text;
        case "path":
            return printPath(exp.items);
        case "unary":
            return printUnary(exp, parentPrecedence);
        case "operator":
        case "comparison":
        case "conjunction":
        case "disjunction":
            return printOperator(exp, parentPrecedence);
        case "ternary":
            return printTernary(exp, parentPrecedence);
        case "call":
            return printFunctionCall(exp.path, exp.args);
        case "map":
            return printMap(exp.items);
        case "array":
            return printArray(exp.items);
        default:
            return "undefined";
    }
}
exports.printSyntax = printSyntax;
// Use precendece levels from Groovy:
// https://docs.groovy-lang.org/2.5.0/html/documentation/core-operators.html#_operator_precedence
function getPrecedence(exp) {
    if (exp.type === "unary") {
        return 1;
    }
    if (exp.type === "operator") {
        switch (exp.token.text) {
            case "*":
            case "/":
            case "%":
                return 4;
            case "+":
            case "-":
            default:
                return 5;
        }
    }
    if (exp.type === "comparison") {
        switch (exp.token.text) {
            case "&lt;":
            case "&lt;=":
            case "&gt;":
            case "&gt;=":
                return 7;
            case "==":
            case "!=":
            default:
                return 8;
        }
    }
    if (exp.type === "conjunction") {
        return 12;
    }
    if (exp.type === "disjunction") {
        return 13;
    }
    if (exp.type === "ternary") {
        return 14;
    }
    return Infinity;
}
//# sourceMappingURL=index.js.map